import { STORAGE } from '../constants/storage.constants';
import { IAuthUserData } from '../pages/Login';

export const getUser = (): IAuthUserData | null => {
  const user = JSON.parse(localStorage.getItem(STORAGE.USER_DATA) || '{}');
  return Object.keys(user).length ? user : null;
};
